import { render, staticRenderFns } from "./NoticeEditor.vue?vue&type=template&id=2ebeb436&scoped=true&"
import script from "./NoticeEditor.vue?vue&type=script&lang=js&"
export * from "./NoticeEditor.vue?vue&type=script&lang=js&"
import style0 from "./NoticeEditor.vue?vue&type=style&index=0&id=2ebeb436&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ebeb436",
  null
  
)

export default component.exports